import { render, staticRenderFns } from "./modal-lista-escogidos.vue?vue&type=template&id=1adb552c&scoped=true"
import script from "./modal-lista-escogidos.vue?vue&type=script&lang=js"
export * from "./modal-lista-escogidos.vue?vue&type=script&lang=js"
import style0 from "./modal-lista-escogidos.vue?vue&type=style&index=0&id=1adb552c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adb552c",
  null
  
)

export default component.exports